//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";
// img
import minus from "../../assets/img/icon/minus.svg";
import total from "../../assets/img/icon/total.svg";

// responsive
import { M, T } from "../../utils/MT";

export default function CancelInfo(props) {
    //페이지 이동
    const navigate = useNavigate();
    const goDetailPage = () => {
        navigate.push(`/product/detail/:` + props.i);
    };

    return (
        <>
            <CancelDetailSection>
                {/* 타이틀 */}
                <MyPageTitleBox>
                    <MyPageTitle>취소/환불정보</MyPageTitle>
                </MyPageTitleBox>

                <OrderInfoBoxWrap>
                    {/* 첫번째 박스 */}
                    <OrderInfoBox>
                        <ProductPayTitle>
                            <OrderText>원결제금액</OrderText>
                            <OrderPay>
                                9,9000,000<span>원</span>
                            </OrderPay>
                        </ProductPayTitle>

                        <OrderDetailContent>
                            <OrderDetailTitle>
                                <OrderDetailText>총 상품금액</OrderDetailText>
                                <OrderDetailPay>
                                    9,9000,000<span>원</span>
                                </OrderDetailPay>
                            </OrderDetailTitle>
                            <OrderDetailTitle>
                                <OrderDetailText>배송비</OrderDetailText>
                                <OrderDetailPay>
                                    0<span>원</span>
                                </OrderDetailPay>
                            </OrderDetailTitle>
                        </OrderDetailContent>
                    </OrderInfoBox>

                    {/* 두번째 박스 */}
                    <OrderInfoBox>
                        <SailTitle>
                            <OrderText>차감금액</OrderText>
                            <OrderPay>
                                0<span>원</span>
                            </OrderPay>
                        </SailTitle>

                        <OrderDetailContent>
                            <OrderDetailTitle>
                                <OrderDetailText>추가배송비</OrderDetailText>
                                <OrderDetailPay>
                                    0<span>원</span>
                                </OrderDetailPay>
                            </OrderDetailTitle>
                            <OrderDetailTitle>
                                <OrderDetailText>반품배송비</OrderDetailText>
                                <OrderDetailPay>
                                    0<span>원</span>
                                </OrderDetailPay>
                            </OrderDetailTitle>
                        </OrderDetailContent>
                    </OrderInfoBox>

                    {/* 두번째 박스 */}
                    <OrderInfoBox>
                        <OrderTitle>
                            <OrderText>총 환불 금액</OrderText>
                            <TotalPay>
                                9,900,000<span>원</span>
                            </TotalPay>
                        </OrderTitle>

                        <OrderDetailContent>
                            <OrderDetailTitle>
                                <OrderDetailText>무통장입금 (가상계좌) 환불</OrderDetailText>
                                <OrderDetailPay>
                                    9,900,000<span>원</span>
                                </OrderDetailPay>
                            </OrderDetailTitle>
                        </OrderDetailContent>
                    </OrderInfoBox>
                </OrderInfoBoxWrap>
            </CancelDetailSection>
        </>
    );
}

const CancelDetailSection = styled.div`
    margin-top: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(50)};
    }
`;
const MyPageTitleBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const MyPageTitle = styled.p`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;
const OrderBtn = styled.button`
    width: calc(100vw * (110 / 1920));
    height: calc(100vw * (35 / 1920));
    font-size: calc(100vw * (11 / 1920));
    margin-top: calc(100vw * (10 / 1920));
    margin-bottom: calc(100vw * (7 / 1920));

    color: var(--main-color);
    border: 1px solid var(--main-color);
    border-radius: 4px;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));
        height: calc(100vw * (35 / 1300));
        font-size: calc(100vw * (11 / 1300));
        margin-top: calc(100vw * (10 / 1300));
        margin-bottom: calc(100vw * (7 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(110)};
        height: ${M(35)};
        font-size: ${M(11)};
        margin-top: ${M(10)};
        margin-bottom: ${M(7)};
    }
`;
// 결제정보

const OrderInfoBoxWrap = styled.ul`
    display: flex;

    // width: calc(100vw * (840 / 1920));
    width: 100%;
    height: calc(100vw * (250 / 1920));
    margin-top: calc(100vw * (20 / 1920));

    border-top: 1px solid #222222;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (250 / 1300));
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;
        height: auto;
        margin-top: ${M(20)};
    }
`;
const OrderInfoBox = styled.li`
    position: relative;
    width: 100%;
    // width: calc(100vw * (280 / 1920));
    height: 100%;

    &:not(:last-child) {
        border-right: 1px solid #dddddd;
    }

    @media screen and (max-width: 900px) {
        &:not(:last-child) {
            border-right: none;
            border-bottom: 1px solid #dddddd;
        }
    }
`;
const OrderTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: calc(100vw * (36 / 1920)) calc(100vw * (25 / 1920));

    background: #fafafa;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (36 / 1300)) calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: auto;
        padding: ${M(23)} 0;
        border-bottom: none;
        background: none;
    }
`;
const ProductPayTitle = styled(OrderTitle)`
    position: relative;

    &::after {
        position: absolute;
        top: 50%;
        right: 0;
        content: "";

        width: calc(100vw * (22 / 1920));
        height: calc(100vw * (22 / 1920));

        background: url(${minus}) no-repeat center center / contain;

        transform: translate(50%, -50%);
        z-index: 1;

        @media screen and (max-width: 1300px) {
            width: calc(100vw * (22 / 1300));
            height: calc(100vw * (22 / 1300));
        }

        @media screen and (max-width: 900px) {
            display: none;
            width: ${M(22)};
            height: ${M(22)};
        }
    }
`;

const SailTitle = styled(OrderTitle)`
    position: relative;

    &::after {
        position: absolute;
        top: 50%;
        right: 0;
        content: "";

        width: calc(100vw * (22 / 1920));
        height: calc(100vw * (22 / 1920));

        background: url(${total}) no-repeat center center / contain;

        transform: translate(50%, -50%);
        z-index: 1;

        @media screen and (max-width: 1300px) {
            width: calc(100vw * (22 / 1300));
            height: calc(100vw * (22 / 1300));
        }

        @media screen and (max-width: 900px) {
            display: none;
            width: ${M(22)};
            height: ${M(22)};
        }
    }
`;
const OrderText = styled.p`
    font-size: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-family: "Noto-B";
        font-size: ${M(15)};
    }
`;
const OrderPay = styled.p`
    font-family: "Noto-B";
    font-size: calc(100vw * (20 / 1920));

    & span {
        margin-left: calc(100vw * (2 / 1920));
        font-family: "Noto-R";
        font-size: calc(100vw * (13 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));

        & span {
            margin-left: calc(100vw * (2 / 1300));
            font-size: calc(100vw * (13 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};

        & span {
            margin-left: ${M(2)};
            font-size: ${M(13)};
        }
    }
`;
const OrderDetailText = styled.p`
    font-size: calc(100vw * (13 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const OrderDetailPay = styled.p`
    display: flex;

    font-size: calc(100vw * (13 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (13 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(13)};
    }
`;
const OrderDetailContent = styled.div`
    padding: calc(100vw * (36 / 1920)) calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (36 / 1300)) calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: 0 0 ${M(27)};
    }
`;
const OrderDetailTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:first-child) {
        margin-top: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        &:not(:first-child) {
            margin-top: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        &:not(:first-child) {
            margin-top: ${M(10)};
        }
    }
`;
const TotalPay = styled(OrderPay)`
    color: var(--main-color);
`;
const BankText = styled(OrderDetailPay)`
    color: #aaaaaa;
`;
